<!-- Assign Task Modal -->
<div class="flx-modal" role="dialog" aria-modal="true" aria-labelledby="assignTitle">
    <div class="flx-modal__header">
        <h2 id="assignTitle">{{data?.orderOwner ? translate?.general.buttons.reAssign.singular + ' ' + translate?.jobOrder.label.singular : translate?.general.buttons.assign.singular + ' ' + translate?.jobOrder.label.singular}}</h2>
        <button class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular" aria-label="Close" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <form [formGroup]="assigneeForm">
        <div class="flx-modal__body">
            <label class="field-label">{{translate?.general.buttons.assign.singular}} {{translate?.general.messages.to}}</label>

            <div class="field-row field-row--auto" [ngClass]="{'mb-0 row-gap-no': assigneeForm.get('assignTo').value == 'user'}">
                <p-dropdown 
                [options]="assignedToOptions"
                formControlName="assignTo"
                optionLabel="name"
                optionValue="value" 
               >
                </p-dropdown>

               

                <p-dropdown 
                placeholder="{{translate?.general.buttons.select2.singular}} {{ assignToLabel }}" 
                    filter="true"
                    [options]="userList" 
                    optionLabel="fullName" 
                    optionValue="id"
                    formControlName="assignToGroup" 
                    *ngIf="assigneeForm.get('assignTo').value && assigneeForm.get('assignTo').value == 'user'">
                </p-dropdown>
                <div>
                    <p-dropdown placeholder="{{translate?.general.buttons.select2.singular}} {{ assignToLabel }}" 
                        filter="true"
                        [options]="groupList"
                        optionLabel="name" 
                        optionValue="id"
                        formControlName="assignToGroup" 
                        *ngIf="assigneeForm.get('assignTo').value && assigneeForm.get('assignTo').value == 'group'">
                    </p-dropdown>
                    <div class="p-error text-10" *ngIf=" assigneeForm.controls['assignToGroup'].touched && assigneeForm.controls['assignToGroup'].hasError('required') ">
                        <span *ngIf="assigneeForm.controls['assignToGroup'].errors?.required" id="label_AssetLocStreetReqField" >{{ translate?.general.validationFE.requiredField }}</span>
                    </div>
                </div>
            </div>

            <div class="note" *ngIf="assigneeForm.get('assignTo').value == 'group'">
                <div class="icon">
                    <i class="fa-regular fa-circle-info" aria-hidden="true"></i>
                </div>
                <p>
                    {{translate?.jobOrder.label.singular}} {{translate?.jobOrder.messages.willBeAssigned}}.
                </p>
            </div>
        </div>

        <div class="flx-modal__footer-between">
            <div class="apply" >
                <ng-container>
                    <div class="p-field-checkbox">
                        <p-checkbox [binary]="true" formControlName="applyToAllTask"></p-checkbox>
                    </div>
                    <span class="text-12">{{translate?.general.buttons.apply.singular}} {{translate?.jobOrder.messages.toAllAdded}} {{translate?.task.label.plural}}</span>
                </ng-container>
            </div>
            <div class="triggers">
                <button type="button"class="custella-btn-white"(click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
                <p-button type="button" [label]="translate?.general.buttons.confirm.singular" styleClass="h-32" (onClick)="onConfirmClick()"></p-button>
            </div>
        </div>
    </form>
</div>